<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

import { useLayout } from "@/layout/common/composables/layout";
import { useHttpErrors } from "@/composables/useHttpErrors";
import { useTokenMonitor } from "@/composables/useTokenMonitor";
import DashboardHeader from "./DashboardHeader.vue";

const route = useRoute();
const { menuMode } = useLayout();

const { errors, removeHttpError } = useHttpErrors();

useTokenMonitor(30000);

const contentContainer = ref<HTMLElement | null>(null);

watch(
  () => route.path,
  () => {
    if (contentContainer.value) {
      contentContainer.value.scrollTop = 0;
    }
  }
);

const latestError = computed(() => {
  const list = errors?.value || [];

  return list.length > 0 ? list[list.length - 1] : null;
});
</script>

<template>
  <div
    class="h-dvh bg-primary-50 dark:bg-surface-950 relative p-2 flex overflow-hidden"
    :class="menuMode === 'horizontal' ? 'flex-col' : 'flex-row'"
  >

    <main
      class="flex-1 max-w-[1720px] w-full mx-auto flex flex-col transition-all duration-300 h-full bg-background rounded-3xl shadow-stroke overflow-hidden"
    >
      <DashboardHeader />

      <div
        class="px-6 pt-4 relative max-h-[180px] flex flex-col"
        v-if="latestError"
      >
        <div class="space-y-3 overflow-y-auto flex-1 pr-2">
          <div class="relative">
            <button
              class="absolute top-2 right-2 z-10 p-1 rounded-full hover:bg-gray-200 transition-colors"
              aria-label="Dismiss error"
              @click="removeHttpError(latestError.id)"
            >
              <i class="pi pi-times text-gray-500 text-sm"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="p-6 flex-1 overflow-auto" ref="contentContainer">
        <RouterView />
      </div>
    </main>

    <Toast />
  </div>
</template>
